import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'ui-product-price-advantage-free',
  imports: [],
  templateUrl: './product-price-advantage-free.component.html',
  styleUrl: './product-price-advantage-free.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPriceAdvantageFreeComponent {
  public small: InputSignal<boolean> = input(false);
}
